import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import Big from 'big.js';
import { ToastrService } from 'ngx-toastr';
import { ModalDialogType } from 'src/app/@core/constants';
import { PosConfirmationService } from 'src/app/@core/services/pos-confirmation.service';
import { Invoice } from 'src/app/models/invoice';
import { Order } from 'src/app/models/order';
import { Payment } from 'src/app/models/payment';
import { CreditReferenceTransactionRequestModel } from 'src/app/models/request/credit-reference-transaction-request-model';
import { PaymentTransactionRequestModel } from 'src/app/models/request/PaymentTransactionRequestModel';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { OrderService } from 'src/app/services/order.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-customer-credit-reference',
  templateUrl: './customer-credit-reference.component.html',
  styleUrls: ['./customer-credit-reference.component.sass'],
})
export class CustomerCreditReferenceComponent implements OnInit {
  invoice: Invoice = new Invoice();
  simulatedOrder: Order = new Order();
  paymentRequest: Array<PaymentTransactionRequestModel> = [];

  invoiceForm: FormGroup = new FormGroup({
    complete: new FormControl(false, Validators.requiredTrue)
  });

  constructor(
    private orderService: OrderService,
    private route: ActivatedRoute,
    private configurationService: ConfigurationService,
    private invoiceService: InvoiceService,
    private readonly confirmService: PosConfirmationService,
    private readonly toastrService: ToastrService,
    private readonly router: Router

  ) { }


  async ngOnInit(): Promise<void> {
    this.simulatedOrder = (
      await this.orderService
        .getOrderForCreditReference(
          this.route.snapshot.params.id,
          this.configurationService.readSelectedBranchAndSalesOrg().salesOrg
            .code,
          this.configurationService.readSelectedBranchAndSalesOrg().branch.code
        )
        .toPromise()
    ).response;

    this.simulatedOrder.orderEntryList[0].code = '1';

    await this.buildInvoiceWithSimulatedOrder();
  }

  async buildInvoiceWithSimulatedOrder(): Promise<void> {
    const request = new PaymentTransactionRequestModel();
    request.paymentsRequestModel.branchCode =
      this.configurationService.readSelectedBranchAndSalesOrg().branch.code;
    request.branchCode =
      this.configurationService.readSelectedBranchAndSalesOrg().branch.code;
    request.paymentsRequestModel.registerCode =
      this.configurationService.readRegister().code;
    request.registerCode = this.configurationService.readRegister().code;
    request.paymentsRequestModel.salesOrgCode =
      this.configurationService.readSelectedBranchAndSalesOrg().salesOrg.code;
    request.fromSimulatedOrder = true;
    request.simulatedOrder = this.simulatedOrder;
    request.invoiceDetails.push({ orderEntryCode: "1", quantity: 1 });

    this.invoice =
      (
        await this.invoiceService
          .simulatePaymentTransaction(request)
          .toPromise()
      ).response.invoices[0] ?? new Invoice();
  }

  buildPaymentTransactionRequest(): PaymentTransactionRequestModel {
    const request = new PaymentTransactionRequestModel();
    request.paymentsRequestModel.branchCode =
      this.configurationService.readSelectedBranchAndSalesOrg().branch.code;
    request.branchCode =
      this.configurationService.readSelectedBranchAndSalesOrg().branch.code;
    request.paymentsRequestModel.registerCode =
      this.configurationService.readRegister().code;
    request.registerCode = this.configurationService.readRegister().code;
    request.paymentsRequestModel.salesOrgCode =
      this.configurationService.readSelectedBranchAndSalesOrg().salesOrg.code;

    return request;
  }


  changeStep(event: any) { }

  buildPaymentsRequest(payments: {
    payments: Array<Payment>;
    paymentsAmount: number;
    id: string;

  }) {
    const paymentRequest = this.buildPaymentTransactionRequest();
    paymentRequest.paymentsRequestModel.payments = payments.payments;
    this.paymentRequest = [paymentRequest];

    //Disable next step
    this.invoiceForm.controls['complete'].setValue(false);
    this.invoiceForm.controls['complete'].markAsPending();

    if (this.invoice.totals.netTotal <= Number(Big(payments.paymentsAmount).round(2).toPrecision())) {
      //Enabled next step
      this.invoiceForm.controls['complete'].setValue(true);
      this.invoiceForm.controls['complete'].markAsDirty();
    }
  }

  async pay(request: Array<PaymentTransactionRequestModel>) {
    await this.confirmService.show("Pagar", `<h3>Está seguro de generar los pagos en la tienda </br> <strong>[${this.configurationService.readSelectedBranchAndSalesOrg().branch.code}] ${this.configurationService.readSelectedBranchAndSalesOrg().branch.name}</strong> </br> con la caja </br> <strong>[${this.configurationService.readRegister().code}] ${this.configurationService.readRegister().name}</strong></h3>`, ModalDialogType.SUCCESS, async () => {
      const transactionRequest = new CreditReferenceTransactionRequestModel();
      transactionRequest.order = this.simulatedOrder;
      transactionRequest.paymentTransaction = request[0];
      transactionRequest.paymentTransaction.invoiceDetails.push({ orderEntryCode: "1", quantity: 1 });
      const response = await this.invoiceService.createCreditReferencesTransaction(transactionRequest).toPromise();
      if (response) {
        Swal.fire({
          title: `Referencia Crediticia`,
          html: `Se creó la factura ${response.response.invoices[0].fullNumber}`,
          icon: 'success',
          confirmButtonText: 'Aceptar',
        });
        this.router.navigate(["orders", response.response.invoices[0].orderCode], {
          queryParams: {
            print: true
          }
        });
      };
    }, undefined, "modal-md");
  }
}
